import classNames from 'classnames/bind';
import GatsbyImage from 'gatsby-image';
import React, { useState } from 'react';

import { APP_NAMES, APPS_CONTENT } from 'components/pages/home/offer/data';
import Heading from 'components/shared/heading';
import Arrow from 'images/pages/home/offer/arrow-small.inline.svg';

import Slide from '../slide';

import styles from './offer-vertical.module.scss';

const cx = classNames.bind(styles);

const OfferVertical = ({ appImages, sticker }) => {
  const ArrowButton = ({ direction, onClick }) => (
    <button className={cx('arrow-button', `arrow-button-${direction}`)} onClick={onClick}>
      <Arrow />
    </button>
  );

  const [direction, setDirection] = useState(null);
  const [currentAppIndex, setCurrentAppIndex] = useState(0);
  const [prevAppIndex, setPrevAppIndex] = useState(APP_NAMES[APP_NAMES.length - 1]);
  const [nextAppIndex, setNextAppIndex] = useState(APP_NAMES[1]);

  const handleRightClick = () => {
    setDirection('right');
    const newCurrentAppIndex = currentAppIndex < APP_NAMES.length - 1 ? currentAppIndex + 1 : 0;
    setCurrentAppIndex(newCurrentAppIndex);
    setPrevAppIndex(newCurrentAppIndex > 0 ? newCurrentAppIndex - 1 : APP_NAMES.length - 1);
    setNextAppIndex(newCurrentAppIndex < APP_NAMES.length - 1 ? newCurrentAppIndex + 1 : 0);
  };

  const handleLeftClick = () => {
    setDirection('left');
    const newCurrentAppIndex = currentAppIndex > 0 ? currentAppIndex - 1 : APP_NAMES.length - 1;
    setCurrentAppIndex(newCurrentAppIndex);
    setPrevAppIndex(newCurrentAppIndex > 0 ? newCurrentAppIndex - 1 : APP_NAMES.length - 1);
    setNextAppIndex(newCurrentAppIndex < APP_NAMES.length - 1 ? newCurrentAppIndex + 1 : 0);
  };

  return (
    <>
      <div className={cx('top', `top-${APP_NAMES[nextAppIndex]}`)}>
        <Heading
          className={cx('top-title')}
          tag="h2"
          size="sm"
          theme="primary"
          innerHTML="we offer"
        />
        <div className={cx('carousel')}>
          <ArrowButton direction="left" onClick={handleLeftClick} />
          <div className={cx('app-names')}>
            {APP_NAMES.map((app, index) => {
              let className = '';
              if (direction === 'left') {
                if (index === currentAppIndex) {
                  className = cx('hide-left');
                }
                if (index === nextAppIndex) {
                  className = cx('show-left', 'current');
                }
              } else if (direction === 'right') {
                if (index === currentAppIndex) {
                  className = cx('hide-right');
                }
                if (index === nextAppIndex) {
                  className = cx('show-right', 'current');
                }
              } else if (index === currentAppIndex) {
                className = cx('current');
              }
              return (
                <Heading
                  key={app}
                  className={cx('app-name', className)}
                  tag="h4"
                  size="lg"
                  theme="primary-inverted"
                >
                  {app}
                </Heading>
              );
            })}
          </div>
          <ArrowButton direction="right" onClick={handleRightClick} />
        </div>
        <div className={cx('sticker')}>
          <GatsbyImage fluid={sticker.childImageSharp.fluid} fadeIn={false} />
        </div>
      </div>
      <div className={cx('bottom')}>
        <div className={cx('slides')}>
          {APP_NAMES.map((appName, index) => {
            let className = cx('slide-wrapper');
            if (direction === 'left') {
              if (index === currentAppIndex) {
                className = cx('slide-wrapper', 'hide-left');
              }
              if (index === nextAppIndex) {
                className = cx('slide-wrapper', 'show-left', 'current');
              }
            } else if (direction === 'right') {
              if (index === currentAppIndex) {
                className = cx('slide-wrapper', 'hide-right');
              }
              if (index === nextAppIndex) {
                className = cx('slide-wrapper', 'show-right', 'current');
              }
            } else if (index === currentAppIndex) {
              className = cx('slide-wrapper', 'current');
            }
            return (
              <div className={className}>
                <Slide
                  key={appName}
                  title={appName}
                  description={APPS_CONTENT[appName].description}
                  appImage={appImages[appName]}
                  link={APPS_CONTENT[appName].link}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default OfferVertical;
